<template lang="html">
    <div class="layout-main">
        <TopBar></TopBar>
        <div class="layout-content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import TopBar from './TopBar';
export default {
    name: 'LayoutHome',
    components: {
        TopBar
    }
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';
.layout-main {
    padding-top: $top-bar-height;
    .home-header {
        max-width: $layout-width;
        margin: auto;
    }
    .home-brand {
        margin: auto;
        max-width: 120px;
        margin: auto;
        padding-top: 5px;
        padding-bottom: 20px;
        @media screen and (min-width: $bp) {
            max-width: 180px;
            padding-top: 20px;
            padding-bottom: 40px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ui/LayoutMain.vue